// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"gTDDS","effectsGrayscale30":"_1hHCT","resetList":"_3SDNt","elementLoadingBackgroundAnimation":"_1FKgO","backgroundAnimation":"_3nLlW"};